var d2 = "/static/e922848148a6ba8e.png";

export { d2 as default };
//# sourceMappingURL=d_2.png.js.map
